
/**
 * Calculate UTM zone and return EPSG code based on map center coordinates
 * @param {Object} mapCenter - Object containing lat and lng properties
 * @param {number} mapCenter.lng - Longitude coordinate
 * @param {number} mapCenter.lat - Latitude coordinate
 * @returns {string} EPSG code (e.g., "EPSG:25832", "EPSG:25833")
 */
export function getUTMZoneEPSG (mapCenter) 
 {
  if (!mapCenter || typeof mapCenter.lng !== 'number') {
    console.warn('Invalid mapCenter provided to getUTMZoneEPSG');
    return "EPSG25832"; // Default fallback
  }

  const { lng } = mapCenter;
  
  // Calculate UTM zone using the formula: floor((longitude + 180) / 6) + 1
  const zone = Math.floor((lng + 180) / 6) + 1;
  
  // Map UTM zones to EPSG codes (UTM Zone 32N and 33N)
  // Zone 32N: 6°E to 12°E → EPSG:25832
  // Zone 33N: 12°E to 18°E → EPSG:25833
  const epsgMap = {
    32: "EPSG25832",
    33: "EPSG25833",
  };

  // Return the EPSG code or default to EPSG:25832
  return epsgMap[zone] || "EPSG25832";
};
